// Proteus Utils -- 2.05

/*
next version: continue development of proteus object to contain all helper/utils functions
^^ paused for now since it will require rebuilding all tretments (or alisases)
*/

window.proteus = window.proteus || {};

proteus.cartAttributes_queue = [];
proteus.cartAttributes_timer = null;
proteus.cartAttributes_debounce_ms = 2500;

proteus.add_cartAttributes = (attrs_array) => {
  if (!Array.isArray(attrs_array) || !attrs_array.length) return;

  // Add to queue
  proteus.cartAttributes_queue.push(...attrs_array);

  // Reset debounce timer
  clearTimeout(proteus.cartAttributes_timer);

  proteus.cartAttributes_timer = setTimeout(() => {
    proteus.flush_cartAttributes();
  }, proteus.cartAttributes_debounce_ms);
}; // proteus.add_cartAttributes()

proteus.flush_cartAttributes = () => {
  if (!proteus.cartAttributes_queue.length) return;

  // De-dupe by key (last write wins)
  const deduped = {};
  proteus.cartAttributes_queue.forEach(pair => {
    const [key] = pair.split("=");
    deduped[key] = pair;
  });

  const body = Object.values(deduped).join("&");

  // Reset queue BEFORE request (important)
  proteus.cartAttributes_queue = [];
  proteus.cartAttributes_timer = null;

  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
    body,
  }).then(res => {
      if (!res.ok) throw new Error("Network response was not ok");
      return res.json();
    }).then(data => {
      console.log("Cart attributes flushed:", data);
      window.cart_attributes_updated = true;
    }).catch(err => {
      console.error("Failed to update cart:", err);
    });
}; // flush_cartAttributes()

/* proteus.add_cartAttribute's multiple_attr_array is legacy script and will eventually be deprecated */
proteus.add_cartAttribute = (attr_name, attr_val, multiple_attr_array = []) => {

  proteus.cartAttributes_queue.push(`attributes[${attr_name}]=${attr_val}`);

  if (typeof attr_name === "string" && attr_name.length) {
    const value =
      attr_val === null || attr_val === undefined
        ? ""
        : String(attr_val);

    proteus.cartAttributes_queue.push(
      `attributes[${encodeURIComponent(attr_name)}]=${encodeURIComponent(value)}`
    );
  }

  if(multiple_attr_array.length > 0){
    proteus.cartAttributes_queue.push(...multiple_attr_array);
  }

  proteus.add_cartAttributes(proteus.cartAttributes_queue);

}

proteus.prep_cartAttributes_from_dl = (
  dl_event_partial = "",
  dl_key = "",
  dl_val = "",
  attr_name_prefix = "proteus-experimentation"
) => {

  // console.log("proteus.prep_cartAttributes_from_dl()");

  // Validate args
  if (dl_event_partial == "" || dl_key == "" || dl_val == "") return;

  // Validate DataLayer
  if (!Array.isArray(window.dataLayer) || window.dataLayer.length === 0) return;

  for (let i = 0; i < window.dataLayer.length; i++) {

    const dl_entry = window.dataLayer[i];
    if (!dl_entry?.event?.includes(dl_event_partial)) continue;

    // console.log(i, dl_entry[dl_key], dl_entry[dl_val]);

    let attr_name = dl_entry[dl_key];
    let attr_val = dl_entry[dl_val];
    if(attr_name_prefix != ""){
      attr_name = `${attr_name_prefix}-${dl_entry[dl_key].toLowerCase()}`;
      attr_val = `[${dl_entry[dl_key]}]${dl_entry[dl_val]}`;
    }

    proteus.cartAttributes_queue.push(`attributes[${attr_name}]=${attr_val}`);

  }

  // console.log("adding", proteus.cartAttributes_queue)
  proteus.add_cartAttributes(proteus.cartAttributes_queue);

};

proteus.get_cookie = (name) => {
  try {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
    return null;
  } catch (e) {
    console.error("Error in get_cookie:", e.message);
    return "v0"; // fallback value
  }
}

proteus.set_cookie = (name, value, days) => {
  try {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    var expires = "expires=" + date.toUTCString();
    document.cookie =
      name + "=" + value + ";" + expires + ";path=/;domain=.{{*Base URL}}";
  } catch (e) {
    console.error("Error in set_cookie:", e.message);
    // Here, you might want to do something else if setting the cookie fails.
    // Returning "v0" may not make sense in this context, but you could still handle the error in some manner.
  }
}

proteus.get_param = (name, optSearch) => {
  "use strict";

  optSearch = optSearch || location.search;
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
    results = regex.exec(optSearch);
  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
};

proteus.wait_for_element = (selector) => {
  return new Promise(function (resolve, reject) {
    var element = document.querySelector(selector);
    if (element) {
      resolve(element);
      return;
    }
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        var nodes = Array.from(mutation.addedNodes);
        for (var _i = 0, _nodes = nodes; _i < _nodes.length; _i++) {
          var node = _nodes[_i];
          if (node.matches && node.matches(selector)) {
            observer.disconnect();
            resolve(node);
            return;
          }
        }
      });
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  });
}

// shim layer with setTimeout fallback
proteus.request_anim_frame = (() => {
  if (window.requestAnimationFrame)
    return window.requestAnimationFrame.bind(window);

  if (window.webkitRequestAnimationFrame)
    return window.webkitRequestAnimationFrame.bind(window);

  if (window.mozRequestAnimationFrame)
    return window.mozRequestAnimationFrame.bind(window);

  return function (callback) {
    return window.setTimeout(callback, 1000 / 60);
  };
})();

proteus.wait_until = (test, timeout = 30000) => { // 30s timeout by default
  return new Promise((resolve) => {
    const poll = () => {
      if (test()) return resolve();
      if (Date.now() - start >= timeout) {
        return reject(new Error("wait_until timed out"));
      }
      window.proteus.request_anim_frame(poll);
    };
    poll();
  });
};

proteus.observe_selector = (selector, callback, options = {
  timeout: null,
  once: false,
  onTimeout: null,
  document: window.document,
}) => {
  var processed = new Map();
  if (options.timeout || options.onTimeout) {
    console.log(
      "------------------------------------------------------------------------------------------------------------------------------",
    );
    console.log(
      "WARNING: observeSelector options timeout and onTimeout are not yet implemented.",
    );
    console.log(
      "------------------------------------------------------------------------------------------------------------------------------",
    );
  }
  var obs,
    isDone = false;
  var done = function done() {
    if (!obs) console.warn("observeSelector failed to run done()");
    if (obs) obs.disconnect();
    processed = undefined;
    obs = undefined;
    return (isDone = true);
  };
  var processElement = function processElement(el) {
    if (processed && !processed.has(el)) {
      processed.set(el, true);
      callback(el);
      if (options.once) {
        done();
        return true;
      }
    }
  };
  var lookForSelector = function lookForSelector() {
    var el =
      arguments.length > 0 && arguments[0] !== undefined
        ? arguments[0]
        : document;
    if (el.matches && el.matches(selector)) {
      if (processElement(el)) return true;
    }
    if (el.querySelectorAll) {
      var elements = el.querySelectorAll(selector);
      if (elements.length) {
        for (var i = 0; i < elements.length; i++) {
          var _el = elements[i];
          if (processElement(_el)) return true;
        }
      }
    }
  };
  lookForSelector();

  //We might finish before the mutation observer is necessary:
  if (!isDone) {
    obs = new MutationObserver(function (mutationsList) {
      mutationsList.forEach(function (record) {
        if (record && record.addedNodes && record.addedNodes.length) {
          for (var i = 0; i < record.addedNodes.length; i++) {
            //Need to check from the parent element since sibling selectors can be thrown off if elements show up in non-sequential order
            var el = record.addedNodes[i].parentElement;
            // if (!el) console.warn('observeSelector element has no parent', record.addedNodes[i], record);
            //Note: This appears to also run when elements are removed from the DOM. If the element doesn't have a parent then we don't need to check it.
            if (el && lookForSelector(el)) return true;
          }
        }
      });
    });
    obs.observe(options.document || document, {
      attributes: false,
      childList: true,
      subtree: true, 
    });
  }
  return function () {
    done();
  };
}; //observeSelector()

// define aliases
window.gtm_add_cartAttribute = proteus.add_cartAttribute;
window.setCookie = proteus.set_cookie;
window.getCookie = proteus.get_cookie;
window.getParam = proteus.get_param;
window.waitForElement = proteus.wait_for_element;
window.requestAnimFrame = function (cb) {
  return proteus.request_anim_frame(cb);
};
window.waitUntil = proteus.wait_until;
window.observeSelector = proteus.observe_selector;

// proteus:cart-changed listener
(function () {

  var START_DELAY = 5000;
  var startTime = Date.now();
  var debounceTimer = null;

  var CART_REGEX = /\/cart(\/(add|update|change|clear)|\.js)/;

  var fallbackAttempted = false;

  async function getSafeCart(cart) {
    if (cart?.items) return cart;

    if (fallbackAttempted) return null;
    fallbackAttempted = true;

    try {
      const res = await fetch("/cart.js");
      return await res.json();
    } catch {
      return null;
    }
  }

  function emitCartEvent(cart) {

    clearTimeout(debounceTimer);

    debounceTimer = setTimeout(async function () {

      const safeCart = await getSafeCart(cart);

      if (!safeCart) return;

      document.dispatchEvent(
        new CustomEvent("proteus:cart-changed", { detail: safeCart })
      );

    }, 100);

  }

  function shouldEmit(url) {
    if (!url) return false;

    if (Date.now() - startTime < START_DELAY) return false;

    return CART_REGEX.test(url);
  }

  function getUrl(input) {
    if (!input) return null;

    if (typeof input === "string") return input;

    if (input.url) return input.url;

    return null;
  }

  // -------------------------
  // FETCH PATCH
  // -------------------------

  if (window.fetch && !window.__proteusFetchPatched) {

    window.__proteusFetchPatched = true;

    const originalFetch = window.fetch;

    window.fetch = function () {

      const args = arguments;
      const url = getUrl(args[0]);

      return originalFetch.apply(this, args)
        .then(response => {

          try {

            if (shouldEmit(url)) {

              response.clone().json()
                .then(cart => emitCartEvent(cart))
                .catch(() => {
                  // fallback if response isn't JSON
                  emitCartEvent(null);
                });

            }

          } catch {}

          return response;

        })
        .catch(() => {
          // 🔇 silent failure (no console error)
          return Promise.resolve(new Response(null, { status: 500 }));
        });

    };

  }

  // -------------------------
  // XHR PATCH
  // -------------------------

  if (window.XMLHttpRequest && !window.__proteusXHRPatched) {

    window.__proteusXHRPatched = true;

    var originalOpen = XMLHttpRequest.prototype.open;

    XMLHttpRequest.prototype.open = function (method, url) {

      if (shouldEmit(url)) {

        this.addEventListener("load", function () {

          try {

            var data = JSON.parse(this.responseText);
            emitCartEvent(data);

          } catch {
            emitCartEvent(null);
          }

        });

      }

      return originalOpen.apply(this, arguments);

    };

  }

})();

// alia event tracking -- v1.0
const aliaEvents = [
  "alia:popupView",
  "alia:signup",
  "alia:popupClose",
  "alia:campaignMatched",
  "alia:pollAnswered",
  "alia:rewardClaimed",
];

aliaEvents.forEach(function (evtName) {
  document.addEventListener(evtName, function (e) {
    console.log("ALIA event:", evtName, e.detail, `ALIA -- ${e.detail.popupID} ${e.detail.type}`);

    window.dataLayer = window.dataLayer || [];

    dataLayer.push({
      event: "proteus_custom_event",
      proteus_event_name: `ALIA -- ${e.detail.popupID} ${e.detail.type}`,
      proteus_event_category: "CRO",
      page_location: window.location.href,
      alia_data: e.detail || {}
    });
  });
});

// postscript popup event tracking -- v1.0
window.addEventListener("postscriptPopup", function(e) {
  // console.log("POSTSCRIPT FULL", e);
  const detail = e?.detail;
  if (!detail || typeof detail !== "object" || !detail.type) return;
  console.log("POSTSCRIPT event", detail);

  window.dataLayer = window.dataLayer || [];
  dataLayer.push({
    'event': 'proteus_custom_event',
    'proteus_event_name': `PS ${e.detail.type} -- ${e.detail.popupId}`,
    'proteus_event_category': "CRO",
    'page_location': window.location.href
  });
});

// klaviyo event tracking -- v1.0
window.addEventListener("klaviyoForms", function(e) {

  console.log("KLAVIYO event", e)

  let form_id = e.detail.formId;
  let test_var = e.detail.formVersionId;

  dataLayer.push({
    'event': 'proteus_custom_event',
    'proteus_event_name': `KL ${form_id} ${e.detail.type} ${test_var}`,
    'proteus_event_category': "CRO",
    'page_location': window.location.href
  });

});

// attentive popup event tracking -- v1.1
window.addEventListener("message", function (e) {

  const a = e?.data?.__attentive;

  if (!a || !a.creativeId || !a.action) return;
  console.log("ATTENTIVE MESSAGE:", e.data);
  window.dataLayer = window.dataLayer || [];

  dataLayer.push({
    event: "proteus_custom_event",
    proteus_event_name: `ATTN ${a.creativeId} -- ${a.action}`,
    proteus_event_category: "CRO",
    page_location: location.href
  });
});

